import * as React from 'react';
import { discardAccessibilityOption } from './data/actions/internalActions';
import { isFeatureEnabled } from 'owa-feature-flags';
import { Option } from 'owa-options-core';
import AccessibilityFull from './components/AccessibilityFull';
import isAccessibilityOptionDirty from './utils/isAccessibilityOptionDirty';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import saveAccessibilityOption from './orchestration/saveAccessibilityOption';

const AccessibilityOption: Option = {
    key: 'accessibilityOption',
    titleStringKey: 'optionTitle_accessibility',
    searchTermsStringKey: 'optionTitle_accessibility',
    fullOptionFormSettings: {
        render: () => <AccessibilityFull />,
        hideSaveDiscard: () => false,
        isDirty: isAccessibilityOptionDirty,
        onSave: saveAccessibilityOption,
        onDiscard: discardAccessibilityOption,
    },
    isHidden: () => isConsumer() || !isFeatureEnabled('cmp-accChecker'),
};

export default AccessibilityOption;
